import React from "react";

const About: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4">

  {/* Project Description */}
  <section className="text-center md:text-justify text-lg leading-relaxed text-gray-700 dark:text-slate-100 mb-16">
    <p className="mb-4">
      Welcome to the Structure of Earnings News — a research-driven system for
      analyzing earnings press releases and their impact on market behavior.
    </p>

    <p>
      Users can upload earnings-related content for prediction, compare
      multiple earnings reports, and explore topic-level attention dynamics
      through structured visualizations.
    </p>
  </section>

  {/* Research Paper */}
  <section className="mb-16">
    <h2 className="text-xl font-bold border-b-2 border-black dark:border-white inline-block mb-5 px-2">
      Research Foundation
    </h2>

    <div className="text-sm text-gray-700 dark:text-slate-300 leading-relaxed space-y-3">
      <p>
        This project is based on the following research paper:
      </p>

      <a
        href="https://doi.org/10.1145/3768292.3770344"
        target="_blank"
        rel="noopener noreferrer"
        className="block"
      >
      <div className="bg-gray-50 dark:bg-slate-900 p-4 rounded-lg text-xs md:text-sm
        transition-all duration-200 ease-out
        hover:shadow-lg hover:shadow-black/10 dark:hover:shadow-black/40
        hover:scale-[1.015]
        hover:bg-gray-100 dark:hover:bg-slate-800
        cursor-pointer
        border border-transparent hover:border-gray-300 dark:hover:border-slate-700">
        <p className="font-semibold mb-2">
          Extracting the Structure of Press Releases for Predicting Earnings Announcement Returns
        </p>
        <p>
          Wu, Y., Akin, E. M., Martineau, C., Grégoire, V., & Veneris, A. (2025)
        </p>
        <p className="mt-2 text-gray-500">
          Proceedings of the 6th ACM International Conference on AI in Finance (ICAIF '25)
        </p>
      </div>
      </a>
    </div>
  </section>

  {/* Authors */}
  <section className="text-center mb-20">
    <h2 className="text-xl font-bold border-b-2 border-black dark:border-white inline-block mb-8 px-2">
      Authors & Contributors
    </h2>

    {/* Paper Authors */}
    <div className="mb-10">
      <h3 className="text-sm uppercase tracking-widest text-gray-500 mb-4">
        Research Authors
      </h3>

      <div className="space-y-3">
        <p className="text-amber-500 font-light">
          <a href="https://yuntaowu2000.github.io/" target="_blank" rel="noopener noreferrer"
            className="text-amber-500 font-light
            transition-all duration-150
            hover:text-amber-400
            hover:underline
            hover:decoration-2
            hover:underline-offset-4"
          >
            Winston (Yuntao) Wu
          </a>
        </p>
        <p className="text-amber-500 font-light">Ege Mert Akin</p>
        <p className="text-amber-500 font-light">
          <a href="https://www.charlesmartineau.com/" target="_blank" rel="noopener noreferrer"
            className="text-amber-500 font-light
            transition-all duration-150
            hover:text-amber-400
            hover:underline
            hover:decoration-2
            hover:underline-offset-4"
          >
            Charles Martineau
          </a>
        </p>
        <p className="text-amber-500 font-light">
          <a href="https://www.vincentgregoire.com/" target="_blank" rel="noopener noreferrer"
            className="text-amber-500 font-light
            transition-all duration-150
            hover:text-amber-400
            hover:underline
            hover:decoration-2
            hover:underline-offset-4"
          >
            Vincent Grégoire
          </a>
        </p>
        <p className="text-amber-500 font-light">
          <a href="https://www.eecg.utoronto.ca/~veneris/AndreasVeneris.htm" target="_blank" rel="noopener noreferrer"
            className="text-amber-500 font-light
            transition-all duration-150
            hover:text-amber-400
            hover:underline
            hover:decoration-2
            hover:underline-offset-4"
          >
            Andreas Veneris
          </a>
        </p>
      </div>
    </div>

    {/* System Developers */}
    <div>
      <h3 className="text-sm uppercase tracking-widest text-gray-500 mb-4">
        Website Developers
      </h3>

      <div className="space-y-3">
        <p className="text-amber-500 font-light">Winston (Yuntao) Wu — University of Toronto</p>
        <p className="text-amber-500 font-light">Kalvin Cui — University of Toronto</p>
        <p className="text-amber-500 font-light">Catherine Li — University of Toronto</p>
        <p className="text-amber-500 font-light">Cindy Wang — University of Toronto</p>
        <p className="text-amber-500 font-light">Vanness Yang — University of Toronto</p>
      </div>
    </div>
  </section>

  {/* Disclaimer */}
  <div className="w-full bg-gray-100 dark:bg-slate-900 rounded-lg p-6 text-xs md:text-sm text-gray-500 dark:text-slate-400 leading-snug">
    <p>
      <span className="font-bold">Disclaimer:</span> All predictions and
      visualizations are model-generated and provided for informational
      purposes only. They do not constitute financial advice. Investing
      involves risk, and users should perform their own due diligence.
    </p>
  </div>

</div>
  );
};

export default About;
